module.exports = __webpack_public_path__ + "plat/static/img/start.faf8e3f5.svg";